import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parseDate'
})
export class ParseDatePipe implements PipeTransform {

  transform(value: string | null): string {
    if (!value) { return ''; }

    // Formato esperado: dd/MM/yyyy HH:mm:ss
    const [datePart, timePart] = value.split(' ');
    const [dd, mm, yyyy] = datePart.split('/');

    if (!dd || !mm || !yyyy) { return value; }

    const formattedTime = timePart ? timePart.substring(0, 5) : '';

    return `${dd}/${mm}/${yyyy} ${formattedTime}`;
  }
}
